interface CanadianTimeZoneRule {
  readonly startsAt: number;
  readonly offsetMinutes: number;
  readonly shortName: string;
  readonly longName: string;
}

const pacific: CanadianTimeZoneRule = {
  startsAt: Date.parse('2026-11-01T09:00:00Z'),
  offsetMinutes: -420,
  shortName: 'MST',
  longName: 'Mountain Standard Time'
};
const mountain: CanadianTimeZoneRule = {
  startsAt: Date.parse('2026-11-01T08:00:00Z'),
  offsetMinutes: -360,
  shortName: 'CST',
  longName: 'Central Standard Time'
};
const central: CanadianTimeZoneRule = {
  startsAt: Date.parse('2026-11-01T07:00:00Z'),
  offsetMinutes: -300,
  shortName: 'EST',
  longName: 'Eastern Standard Time'
};

const rules = new Map<string, CanadianTimeZoneRule>([
  ['America/Vancouver', pacific],
  ['Canada/Pacific', pacific],
  ['America/Edmonton', mountain],
  ['Canada/Mountain', mountain],
  ['America/Yellowknife', mountain],
  ['America/Winnipeg', central],
  ['Canada/Central', central],
  ['America/Rainy_River', central]
]);

export const canadianTimeZoneRule = (
  timeZone: string,
  timestamp: number
): CanadianTimeZoneRule | undefined => {
  const rule = rules.get(timeZone);
  return rule && timestamp >= rule.startsAt ? rule : undefined;
};
